// Окно «пользователь ушёл по нашему офферу».
//
// Пока оно открыто, свёрнутое приложение — это ожидаемое состояние, а не причина
// останавливать монетизацию: фоновая цепочка продолжает крутиться. Ровно так же
// это устроено в postingBot (offerVisitRef в PromotionContext).

const OFFER_OPEN_VISIBILITY_WINDOW_MS = 15_000;
const OFFER_RETURN_WINDOW_MS = 30 * 60_000;

interface OfferVisit {
  trigger: string;
  openedAt: number;
  hiddenAt: number | null;
}

let visit: OfferVisit | null = null;
let listenerInstalled = false;

function onVisibilityChange() {
  if (!visit) return;

  if (document.visibilityState === 'hidden') {
    // Свернулись слишком поздно после редиректа — значит, не из-за него.
    if (Date.now() - visit.openedAt > OFFER_OPEN_VISIBILITY_WINDOW_MS) {
      visit = null;
      return;
    }
    visit.hiddenAt = Date.now();
    return;
  }

  // Пользователь вернулся — окно закрываем.
  if (visit.hiddenAt || Date.now() - visit.openedAt > OFFER_OPEN_VISIBILITY_WINDOW_MS) {
    visit = null;
  }
}

export function markOfferVisit(trigger: string): void {
  if (!listenerInstalled) {
    listenerInstalled = true;
    document.addEventListener('visibilitychange', onVisibilityChange);
  }
  visit = { trigger, openedAt: Date.now(), hiddenAt: null };
}

export function hasActiveOfferVisit(): boolean {
  if (!visit) return false;
  // На мобиле скрипт совместимости гасит visibilitychange, поэтому окно не закроется
  // по событию — обязательно нужен предельный срок жизни.
  if (Date.now() - visit.openedAt > OFFER_RETURN_WINDOW_MS) {
    visit = null;
    return false;
  }
  return true;
}
